import React from 'react';
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import ContentPanel from "../../../components/ContentPanel/ContentPanel";
import Skeleton from "../../../components/Skeleton/Skeleton";
import SizeCalculator from "../../../components/SizeCalculator/SizeCalculator";
import store from "../../../store";
import {Helmet} from "react-helmet";

const cargoBinCapacities = () => {
  return (
    <div className="wrapper pbl mbm">
        <Helmet>
            {
                store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                    return row.rowTitle === "Ship" ? row.sections.map((section) => {
                        return section.title === "Guidelines & Tools" ? section.subsections.map((subsection) => {
                                    return subsection.title === "Cargo Bin Capacities" ? <meta name="description" content={subsection.content['seo-description']}/> : null
                                })
                                : null
                    }) : null
                }) : null
            }
        </Helmet>
      <Breadcrumbs/>
      <ContentPanel
        skeleton={<Skeleton type="MAIN_PANEL"/>}
        errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
        templateUrl="./content/ship/page-components/text-block/bin-capacities-heading.html"
      />
      <ContentPanel
        skeleton={<Skeleton type="MAIN_PANEL"/>}
        errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
        templateUrl="./content/ship/page-components/content-detail/bin-capacities-body-1.html"
      />
      <h4 className="mtl pts">Maximum weight</h4>
      <div className="table table--maximum-weight table--top-spaced">
        <div className="table__row table__row--maximum-weight">
          <div className="table__heading table__heading--half-width table__heading--left-aligned table__heading--cargo-bin-capacities">Maximum weight</div>
          <div className="table__body table__body--flex-container">
            <div className="mb12">
              <span className="table__body-bold-text">250</span> lbs/piece
            </div>
            <div>
              <span className="table__body-bold-text">175</span> lbs/piece for seafood
            </div>
          </div>
        </div>
        <div className="table__row table__row--maximum-weight">
          <div className="table__heading table__heading--half-width table__heading--left-aligned table__heading--cargo-bin-capacities">Floor bearing weight</div>
          <div className="table__body table__body--flex-container">
            <div className="mb12">
              <span className="table__body-bold-text">150</span> lbs/sq ft
            </div>
            <div>
              <span className="table__body-bold-text">.073</span> kgs/sq cm
            </div>
          </div>
        </div>
      </div>
      <h4 className="mtl ptm">Maximum cargo capacity (US standards)</h4>
      <div className="table table--top-spaced">
        <div className="table__row table__row--maximum-weight">
          <div className="table__heading table__heading--cargo-bin-capacities">&nbsp;</div>
          <div className="table__body table__body--flex-container table__body--fixed-height-title">
            <div className="mb12">
              <div className="table__body-heading">Forward</div>
            </div>
          </div>
          <div className="table__body table__body--flex-container table__body--fixed-height-title table__body--top-border">
            <div className="mb12">
              <div className="table__body-heading">Aft</div>
            </div>
          </div>
        </div>
        <div className="table__row table__row--cargo-bin-capacity">
          <div className="table__heading table__heading--cargo-bin-capacities">Weight</div>
          <div className="table__body table__body--flex-container">
            <div className="mb12">
              <span className="table__body-bold-text">4,424</span> lbs
            </div>
            <div>
              <span className="table__body-bold-text">2,007</span> kgs
            </div>
          </div>
          <div className="table__body table__body--flex-container table__body--top-border">
            <div className="mb12">
                <span className="table__body-bold-text">6,998</span> lbs
            </div>
            <div>
              <span className="table__body-bold-text">3,175</span> kgs
            </div>
          </div>
        </div>
        <div className="table__row table__row--cargo-bin-capacity">
          <div className="table__heading table__heading--cargo-bin-capacities">Volume</div>
          <div className="table__body table__body--flex-container">
            <div className="mb12">
              <span className="table__body-bold-text">386</span> cu ft
            </div>
            <div>
              <span className="table__body-bold-text">10.9</span> cu m
            </div>
          </div>
          <div className="table__body table__body--flex-container table__body--top-border">
            <div className="mb12">
              <span className="table__body-bold-text">580</span> cu ft
            </div>
            <div>
              <span className="table__body-bold-text">16.4</span> cu m
            </div>
          </div>
        </div>
        <div className="table__row table__row--cargo-bin-capacity">
          <div className="table__heading table__heading--cargo-bin-capacities">Door opening</div>
          <div className="table__body table__body--flex-container">
            <div className="mb12">
              <span className="table__body-bold-text">48 x 35</span> in
            </div>
            <div>
              <span className="table__body-bold-text">122 x 89</span> cm
            </div>
          </div>
          <div className="table__body table__body--flex-container table__body--top-border">
            <div className="mb12">
              <span className="table__body-bold-text">48 x 35</span> in
            </div>
            <div>
              <span className="table__body-bold-text">122 x 89</span> cm
            </div>
          </div>
        </div>
      </div>
      <h4 className="mtl ptm">Southwest cargo size calculator</h4>
      <p className="mtm pts">To determine the maximum acceptable length of your bulk piece, find the height and width (or next largest measurement) of your piece from the chart below. The intersection of the height and weight will be the maximum acceptable length of your piece. (Shown in inches).</p>
      <div className="break-wrapper">
        <SizeCalculator/>
      </div>
      <p>Package length is limited to a maximum of 161 inches / 408.94 cm when traverse cargo nets (webbing) are installed. </p>
      <p>Please note, Southwest Airlines® flies several different series Boeing 737 aircraft. The sizing chart provided is for all aircraft (737 -700, MAX7, -800 and MAX8). The aircraft type cannot be guaranteed on a per flight basis. For specific questions related to a specific flight, please contact your local cargo facility or our Customer CARE Center at  (800) 533-1222. </p>
      <p>NOTE: Due to the containerization of Hawaiian Airlines’ cargo, the maximum piece length that can be interlined is 120 inches. </p>
    </div>
  )
}

export default cargoBinCapacities;



// WEBPACK FOOTER //
// ./src/pages/ship/GuidelinesAndTools/CargoBinCapacities.js